var map = {
	"./PHZ.jpg": "./src/assets/tizhi/PHZ.jpg",
	"./QXZ.jpg": "./src/assets/tizhi/QXZ.jpg",
	"./QYZ.jpg": "./src/assets/tizhi/QYZ.jpg",
	"./SRZ.jpg": "./src/assets/tizhi/SRZ.jpg",
	"./TBZ.jpg": "./src/assets/tizhi/TBZ.jpg",
	"./XYZ.jpg": "./src/assets/tizhi/XYZ.jpg",
	"./YANGXZ.jpg": "./src/assets/tizhi/YANGXZ.jpg",
	"./YINXZ.jpg": "./src/assets/tizhi/YINXZ.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/tizhi sync recursive ^\\.\\/.*\\.jpg$";